import { uploadImage } from '@/api/storage';
import { EditorOptions as VanillaTuiEditorOptions } from '@toast-ui/editor';
import { EditorOptions } from './type';

type TuiEditorOptions = Omit<VanillaTuiEditorOptions, 'el'>

export const defineEditorOptions = ({ placeholder }: EditorOptions): TuiEditorOptions => ({
    language: 'ko',
    usageStatistics: false,
    hideModeSwitch: true,
    placeholder,
    toolbarItems: [[
        'heading',
        'bold',
        'italic',
        'hr',
        'quote',
        'ul',
        'ol',
        'image',
        'link',
    ]],
    hooks: {
        addImageBlobHook: async (blob, callback) => {
            const uploadedImage = await uploadImage(blob as File);
            callback(uploadedImage.src, 'Изображение');
        }
    }
})
